<div class="d-md-flex align-items-center  p-2"  style="background-color: #87858525;">
    <span class="d-flex align-items-center p-2 ">
    <h5 class="mb-0 mr-1 text-dark font-weight-bold font-14">{{'RMA.attivita.title' | translate}}:</h5>
    <span class="badge badge-danger badge-pill px-3 font-weight-bold font-14" *ngIf="ListaScadenze">{{ListaScadenze.length}}</span>
    </span>
  <div class="ml-auto mt-3 mt-md-0">
    <button type="button" *ngIf="editEnabled" (click)="ScadAddButton()" class="btn btn-cyan rounded-pill p-2" ><i
      class="fas fa-plus  font-14 mr-1 text-white"></i>
      <span class="ml-1 text-white font-weight-bold">{{'RMA.attivita.title' | translate}}</span>
    </button>
  </div>
</div>
<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0 ">
    <thead *ngIf="!hasDynamicHeader()">
    <tr>
      <th >Esito</th>
      <th scope="col">{{'Data Inizio' | translate}}</th>
      <th scope="col">{{'Data Fine' | translate}}</th>
      <th scope="col">{{'Attività' | translate}}</th>
      <th scope="col">{{'RMA.attivita.azioni' | translate}}</th>
    </tr>
    </thead>
    <thead *ngIf="hasDynamicHeader()">
    <tr *ngIf="environment.RmaAddOn['CampiEsito']">
      <ng-container *ngFor="let campo of environment.RmaAddOn['CampiEsito']">
        <th scope="col" *ngIf="permission.isntOperativeRoles(campo.prohibitedRoles) && permission.isOperativeRoles(campo.AllowedRoles) && campo.viewInList" >{{campo.nome | translate}}</th>
      </ng-container>
      <th scope="col" >Azioni</th>
    </tr>
    </thead>
    <tbody *ngIf="!hasDynamicHeader()">
    <tr *ngFor="let scadenza of ListaScadenze">
      <td>
        <span class="text-dark font-medium font-16">
          {{ scadenza?.statoObject?.label}}
          </span>
      </td>
      <td class="align-middle">
        <span class="text-dark font-medium font-16">
          {{ scadenza.data_inizio_effettiva | date: "dd/MM/yyyy HH:mm"}}
        </span>
      </td>
      <td class="align-middle">
        <span class="text-dark font-medium font-16">
          {{ scadenza.data_fine_effettiva | date: "dd/MM/yyyy HH:mm"}}
        </span>
      </td>
      <td class="align-middle">
        <span class="text-dark font-medium font-16">
          {{ scadenza?.attivitaObject?.check}}
        </span>
      </td>
      <td class="align-middle">
        <a href="javascript:void(0)" *ngIf="editEnabled" class="link font-16 text-info font-medium mr-2" (click)="ScadModBtn(scadenza)">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="editEnabled"  class="link font-16 text-danger font-medium mr-2" (click)="Delete(scadenza)">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
    <tbody *ngIf="hasDynamicHeader()">
    <tr *ngFor="let scadenza of ListaScadenze">
      <ng-container *ngFor="let campo of environment.RmaAddOn['CampiEsito']">
        <td class="align-middle" [ngClass]="campo.class" *ngIf="campo.viewInList">
          <app-list-campo-viewer [campo]="campo" [Oggetto]="scadenza"></app-list-campo-viewer>
        </td>
      </ng-container>
      <td class="align-middle">
        <a href="javascript:void(0)" *ngIf="editEnabled" class="link font-16 text-info font-medium mr-2" (click)="ScadModBtn(scadenza)">
          <i class="fas fa-pencil-alt"></i>
        </a>
        <a href="javascript:void(0)" *ngIf="editEnabled" class="link font-16 text-danger font-medium mr-2" (click)="Delete(scadenza)">
          <i class="fas fa-trash-alt"></i>
        </a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
